import { FileText } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { btn } from "@/components/ui-kit";

export const openPoFile = async (fid) => {
  const w = window.open("", "_blank");
  try {
    const r = await api.get(`/po-files/${fid}`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    if (w) w.location.href = url;
    else window.location.href = url;
  } catch (e) {
    if (w) w.close();
    toast.error(errMsg(e));
  }
};

export const ViewPoButton = ({ fid, testId = "view-original-po-btn", small }) =>
  fid ? (
    <Button size={small ? "sm" : "default"} variant="ghost" onClick={(e) => { e.stopPropagation(); openPoFile(fid); }} className={btn.ghost} data-testid={testId}>
      <FileText className="mr-1.5 h-4 w-4" /> View original PO
    </Button>
  ) : null;
